import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Icons from './icons';
import LinkedinIcon from 'grommet/components/icons/base/SocialLinkedinOption';
import EmailModal from 'medscape/email-modal';
import TrackingActions from 'medscape/tracking';
import Utils from 'medscape/utils';

export default class SharingWidget extends React.Component {
    constructor(props) {
        super(props);
        this.handleEvent = this.handleEvent.bind(this);
        this.handleOn = this.handleOn.bind(this);
        this.handleOff = this.handleOff.bind(this);
        this.state ={
            "display":false
        }
        const widgetId = Math.floor(Math.random() * 9999999999);
        const eventName = `shareWidget-${props["config-id"]}-${widgetId}`;
        this.eventType = Utils.isMobile() ? `touchend.${eventName}` : `click.${eventName}`;
        this.eventTimer = null;
    }

    handleEvent(e){
        let currentState = this.state.display;

        if(e.target.className === "groupEmail" || e.target.className.baseVal === "groupEmail" || e.target.className.baseVal === "groupEmailText"){
            TrackingActions.pageLink('share-email');
            EmailModal.open();
        }

        this.setState({"display": !currentState});

    }

    handleOn(e){

        clearTimeout(this.eventTimer);
        this.setState({"display":true});
    }
    handleOff(e){

         this.setState({"display":false});
    }
    componentDidMount() {
        let $this = $(ReactDOM.findDOMNode(this));
        TrackingActions.trackContainerLinks($this[0]);

    }
    componentWillUnmount(){
        $(document).off(this.eventType);
    }
    componentDidUpdate(prevProps,prevState){
        if(!prevState.display && this.state.display){
            $(document).one(this.eventType,(e)=>{
                if(e.target.className.baseVal=="groupSharing"||e.target.className.baseVal=="groupSharingText"){
                    return
                }
                clearTimeout(this.eventTimer);
                this.eventTimer = setTimeout(()=>{
                    this.handleOff();
                },100);
             });
        }
    }
    render() {
        let itemProps = {
            "icon-className": this.props['itemClassName'],
            "icon-facebook": this.props["icon-facebook"],
            "icon-twitter": this.props["icon-twitter"],
            "icon-google": this.props["icon-google"],
            "icon-linkedin": this.props["icon-linkedin"],
            "icon-email": this.props["icon-email"],
            "icon-display": this.state.display,
            "handleOff": this.handleOff,
            "handleOn": this.handleOn
        }
        if(this.props["pIcon-show"]){
            const groupProps = {
                className: this.props['itemClassName'],
                icon: this.props['parent-icon'],
                handleChange: this.handleEvent,
                turnOn: this.handleOn,
                turnOff: this.handleOff
            }
           return (
            <div className="share-widget">
            <ShareItemGroup {...groupProps} />
            <ShareItemDisplay {...itemProps}/>
            </div>
        )
        }else{
        itemProps['icon-display'] = true;
        return(<div className="share-widget">
                <ShareItemDisplay {...itemProps}/>
               </div>)
        }
    }
}
SharingWidget.propTypes={
    "config-id": React.PropTypes.string,
    "icon-facebook": React.PropTypes.string,
    "icon-twitter": React.PropTypes.string,
    "icon-google": React.PropTypes.string,
    "icon-email": React.PropTypes.string,
    "icon-linkedin": React.PropTypes.string,
    "icon-group-sharing": React.PropTypes.string
}
SharingWidget.defaultProps={
    "config-id": "share-widget",
    "icon-facebook": "default",
    "icon-twitter": "default",
    "icon-google": "default",
    "icon-email": "default",
    "icon-linkedin": "default",
    "icon-group-sharing": "default"
}

class ShareItemDisplay extends React.Component{
    constructor(props) {
        super(props);
    }
    render(){
        if(!this.props["icon-display"] || this.props['icon-className'] === "groupEmail"){
            return null;
        }
        else{
            const containerProps = {
                id: "widgetContainer",
                className: "listContainer"
            }
            if(!Utils.isMobile()){
                containerProps.onMouseLeave=this.props.handleOff;
                containerProps.onMouseEnter = this.props.handleOn;
            }

             return(
              <div {...containerProps}>
                    <div className="listWrap">
                        <ul className="share-widget-list">
                             <ShareItem className="facebook" button-class="fb-share-button" icon={this.props['icon-facebook']} />
                             <ShareItem className="twitter" icon={this.props['icon-twitter']} />
                             <ShareItem className="google" icon={this.props['icon-google']} />
                             <ShareItem className="linkedin" icon={this.props['icon-linkedin']} />
                             <ShareItem className="email" icon={this.props['icon-email']} />
                        </ul>
                    </div>
               </div>
            );
        }
    }
}

class ShareItemGroup extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        if(this.props.icon.length>0){
            let icon = this.getIcon();
            let aProps = {
                onClick:this.props.handleChange
            }
            if(!Utils.isMobile()){
                aProps.onMouseLeave=this.props.turnOff;
                aProps.onMouseEnter=this.props.turnOn;
            }
            return(
                <div className={this.props.className}><a {...aProps}>{ icon }</a></div>
            )
        }
        return false;
    } // render

    componentDidMount(){

    } // componentDidMount


    getIcon(){
        let icon = false;
        if(this.props.icon!=='default'){

            icon = ( <img className="groupEmail" src={Utils.imageServer()+this.props.icon}/>)
        }
        else{
        switch(this.props.className){
                case 'groupEmail':
                    icon = (<Icons.groupEmail/>);
                    break;
                case 'groupSharing':
                    icon = (<Icons.groupSharing />);
                    break;
                default:
                    icon = false;
            }
        }
        return icon;
    }
} // ShareItem

class ShareItem extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        if(this.props.icon.length>0){
            let icon = this.getIcon();
            let linkProps = this.getLinkProps();
            return(
                <li className={this.props.className}><a {...linkProps}>{ icon }</a></li>
            )
        }
        return false;
    } // render

    componentDidMount(){

    } // componentDidMount
    getLinkProps(){
        let props = {};
        let location = encodeURIComponent(document.querySelector('meta[property="og:url"]').getAttribute('content'));
        let title = encodeURIComponent(document.querySelector('meta[property="og:title"]').getAttribute('content'));
        let pageLink,src;
        let url = 'javascript:void(0);'
        let onClick = this.props.className=="email" ? this.onClickEmail.bind(this) : this.onClickShare.bind(this);
        switch(this.props.className){
            case 'facebook':
                src= encodeURIComponent("stfb");
                pageLink = 'share-fbook';
                url  = `https://www.facebook.com/sharer.php?u=${location}&title=${title}&src=${src}`;
                break;
            case 'twitter':
                src= encodeURIComponent("sttwit");
                pageLink = 'share-twitt';
                url  = `https://twitter.com/share?url=${location}&title=${title}&src=${src}`;
                break;
            case 'google':
                src= encodeURIComponent("stgoogle")
                pageLink = 'share-googl'
                url  = `https://plusone.google.com/_/+1/confirm?url=${location}&title=${title}&src=${src}`
                break;
            case 'linkedin':
                src= encodeURIComponent("stlinkedin");
                pageLink = 'share-lnkdn';
                url  = `https://www.linkedin.com/cws/share?url=${location}&title=${title}&src=${src}`;
                break;
            case 'email':
                pageLink = 'share-email';
                break;
            default:
                 src = null;
        }
        props = {
            href: url,
            target: '_blank',
            "data-pageLink": pageLink,
            className: this.props["button-class"]
        }
        if(Utils.isMobile()){
            props.onTouchStart = onClick;
        }
        else{
            props.onClick = onClick;
        }
        return props;

    }

    onClickEmail(e) {
        e.preventDefault();
        TrackingActions.pageLink('share-email');
        EmailModal.open();
    }
    onClickPrint() {
      //TrackingActions.pageLink('/soc_bpm_print-v');
    }

    onClickShare(e){
        //e.preventDefault();
        let el = e.currentTarget;
        let url = el.getAttribute('href');
        let tracking = el.dataset.pagelink;
        //window.open(url, "_blank", "width=600, height=400, scrollbars=no");
        TrackingActions.pageLink(tracking);
        return true;
    }
    getIcon(){
        let icon = false;
        if(this.props.icon!=='default'){
            icon = ( <img src={Utils.imageServer()+this.props.icon} />)
        }
        else{
            switch(this.props.className){
                case 'facebook':
                    icon = (<Icons.facebook />);
                    break;
                case 'twitter':
                    icon = (<Icons.twitter />);
                    break;
                case 'google':
                    icon = (<Icons.google />);
                    break;
                case 'linkedin':
                    icon = (<LinkedinIcon/>) ;
                    break;
                case 'email':
                    if(window.medscape.user.isLoggedIn){
                    icon = (<Icons.email />) ;
                    }
                    break;
                default:
                    icon = false;
            }
        }
        return icon;
    }
} // ShareItem
ShareItem.propTypes={
    "icon": React.PropTypes.string,
    "className": React.PropTypes.string,
    "button-class": React.PropTypes.string
}
ShareItem.defaultProps={
    "icon": "default",
    "className": "",
    "button-class": ""
}



// WEBPACK FOOTER //
// ./medscape_modules/share-widget/app.jsx